export const NETFLIX_LOGO =
	"https://fontmeme.com/temporary/userlmn_92494c9b557b73863c668d44ac89dcfb.png";
export const USER_LOGO =
	"https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg";

export const BACKGROUND =
	"https://assets.nflxext.com/ffe/siteui/vlv3/dae1f45f-c2c5-4a62-8d58-6e1b0c6b2d8e/6d1fb8a4-5844-42a4-9b01-1c6c128acf19/IN-en-20240827-TRIFECTA-perspective_WEB_c292a608-cdc6-4686-8dc8-405bfcf753af_large.jpg";

export const API_OPTIONS = {
	method: "GET",
	headers: {
		accept: "application/json",
		Authorization:
			"Bearer  eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYTdlOGRiOTI3YTI0YzRlZjkxNDI2M2Y5ODAxYWMyNCIsIm5iZiI6MTcwMjQwNDM5NS45NTYsInN1YiI6IjY1NzhhMTJiNTY0ZWM3MDEzOGJkMTFiNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ._xc9N0xWueGK5G-mUFpNrrVBJFd1JPIimADNzVQWhOU",
	},
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500";

export const SUPPORTED_LANGUAGES = [
	{ identifier: "en", name: "English" },
	{ identifier: "hindi", name: "Hindi" },
	{ identifier: "bhoj", name: "Bhojpuri" },
];

export const GEMINI_GPT_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
